import { render } from "./StatWindow.vue?vue&type=template&id=2700a6c3&scoped=true"
import script from "./StatWindow.vue?vue&type=script&lang=js"
export * from "./StatWindow.vue?vue&type=script&lang=js"

import "./StatWindow.vue?vue&type=style&index=0&id=2700a6c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2700a6c3"]])

export default __exports__